module.exports = __webpack_public_path__ + "static/diego_moeller-99c50e9b023d6fab1c275414d680f0bd.jpg";